// src/Components/Banner/BannerCarousel.jsx
import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './BannerCarousel.css';

const BannerCarousel = ({ items }) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    pauseOnHover: true,
    variableWidth: true,
    slidesToShow: 1.1,
    slidesToScroll: 1,
  };

  return (
    <div className="banner-carousel-wrapper">
      <Slider {...settings} className="banner-carousel">
        {items.map((evt) => (
          <div key={evt.id}>
            <a
              href={evt.link}
              target="_blank"
              rel="noopener noreferrer"
              className="banner-item-link"
            >
              <div className="banner-item">
                <img
                  src={evt.image_url}
                  alt={evt.title}
                  className="banner-image"
                />
                <div className="banner-overlay">
                  <h3 className="banner-title">{evt.title}</h3>
                  <p className="banner-desc">{evt.description}</p>
                </div>
              </div>
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BannerCarousel;
